// CartContext.js
import { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const CartContext = createContext();

export function CartProvider({ children }) {
    const [modalProduct, setModalProduct] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [cart, setCart] = useState(() => {
        if (typeof window !== 'undefined') {
            const savedCart = localStorage.getItem('cart');
            return savedCart ? JSON.parse(savedCart) : [];
        }
        return [];
    });
    
    useEffect(() => {
        const savedCart = localStorage.getItem('cart');
        const savedTimestamp = localStorage.getItem('cart_timestamp');
        
        // Reset cart if older than 7 days
        if (savedTimestamp && Date.now() - savedTimestamp > 7 * 24 * 60 * 60 * 1000) {
            localStorage.removeItem('cart');
            localStorage.removeItem('cart_timestamp');
            return;
        }
        
        if (savedCart) {
            setCart(JSON.parse(savedCart));
        }
    }, []);

    useEffect(() => {
        localStorage.setItem('cart', JSON.stringify(cart));
        localStorage.setItem('cart_timestamp', Date.now());
    }, [cart]);

    const showToast = (message, product) => {
        toast.success(
            <div>
                <div>{message}</div>
                <div style={{ fontSize: '0.9rem', marginTop: '4px' }}>
                    {product.title}
                </div>
            </div>, 
            {
                toastId: product.id,
                position: "top-center",
                autoClose: 1500,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                style: {
                    borderRadius: '4px',
                    color: 'black'
                }
            }
        );
    };

    const addToCart = (product, quantite = 1, calibrage = 0) => {
        console.log(product)
        console.log(quantite)
        console.log(calibrage)
        setCart(prevCart => {
            const existingItem = prevCart.find(item => item.id === product.id);
            
            if (existingItem) {
                // Update existing item
                return prevCart.map(item =>
                    item.id === product.id
                        ? { ...item, quantity: quantite || item.quantity + 1, calibrage }
                        : item
                );
            } else {
                // Add new item
                return [...prevCart, { 
                    ...product, 
                    quantity: quantite || 1, 
                    calibrage 
                }];
            }
        });

        // Show modal
        setModalProduct(product);
        setIsModalOpen(true);
    };

    const removeFromCart = (productId) => {
        setCart(prevCart => prevCart.filter(item => item.id !== productId));
    };

    const updateQuantity = (productId, newQuantity) => {
        if (newQuantity < 1) {
            removeFromCart(productId);
            return;
        }
        
        setCart(prevCart =>
            prevCart.map(item =>
                item.id === productId
                    ? { ...item, quantity: newQuantity }
                    : item
            )
        );
    };

    const clearCart = () => {
        setCart([]);
        localStorage.removeItem('cart');
        localStorage.removeItem('cart_timestamp');
    };

    const cartTotal = cart.reduce((total, item) => {
    const discountedPrice = item.promotion
        ? item.price * (1 - item.promotion / 100)
        : item.price;

        return total + (discountedPrice * item.quantity) + (parseFloat(item.calibrage) * item.quantity);
    }, 0);


    return (
        <CartContext.Provider
            value={{
                cart,
                addToCart,
                removeFromCart,
                updateQuantity,
                cartTotal,
                cartCount: cart.reduce((count, item) => count + item.quantity, 0),
                clearCart,
                modalProduct,
                isModalOpen,
                closeModal: () => setIsModalOpen(false)
            }}
        >
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);